<script>
  import Fa from 'svelte-fa';

  export let icon;
  export let title = "";
  export let color = "#666";
  export let size = "1x";
</script>

<button type="button" {title} on:click>
  <Fa {icon} {color} {size} />
</button>

<style>
  button {
    background-color: transparent;
    border: none;
    margin: auto;
    padding: 2px;
    margin: 0;
    cursor: pointer;
    opacity: 80%;
  }

  button:hover {
    opacity: 90%;
  }

  button:active:hover {
    opacity: 100%;
  }

  button:focus {
    background-color: transparent;
  }
</style>